import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'transparent',
    color: '#262626',
    width: '100%',
    alignItems: 'center',
    fontSize: '12px',
    minHeight: '32px',
    height: 'auto',
    borderRadius: '4px',
    boxShadow: 'transparent',
    borderColor: state.isFocused ? 'rgb(31, 70, 128)' : '#dbdbdb',
    outline: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    overflowX: 'auto',
    paddingRight: '10px',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#ffe9d2',
    padding: '0px 4px',
    borderRadius: '4px',
    display: 'inline-flex',
    maxWidth: 'none',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ab5c00',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#ab5c00',
    cursor: 'pointer',
    ':hover': {
      color: '#ab5c00',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#262626',
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#262626',
    backgroundColor: state.isFocused ? 'rgba(31, 70, 128, 0.1)' : 'white',
    cursor: 'pointer',
    fontSize: '12px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  indicatorSeparator: () => ({}),
};

function FilterMultiSelect({ options, onChange, disabled, ...props }) {
  return (
    <Select
      isMulti
      options={options}
      onChange={onChange}
      styles={customStyles}
      isDisabled={disabled}
      menuPlacement="auto"
      {...props}
    />
  );
}

export default FilterMultiSelect;
